var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m331 91c0-33.472-18.604-64.574-48.545-79.545l-19.746-9.873c-4.219-2.109-9.199-2.109-13.418 0l-19.746 9.873c-29.941 14.971-48.545 46.073-48.545 79.545v60h150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 301c41.367 0 75-33.647 75-75v-45h-150v45c0 41.353 33.633 75 75 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 512h61v-145.155l-73.861 122.435c-2.783 4.644-2.842 10.415-.205 15.117 2.666 4.703 7.675 7.603 13.066 7.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.066 504.397c2.637-4.702 2.578-10.474-.205-15.117l-73.861-122.435v145.155h61c5.391 0 10.4-2.9 13.066-7.603z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211 301h90v30h-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 316c0-8.286-6.716-15-15-15h-60v45c0 8.291-6.709 15-15 15h-120c-8.291 0-15-6.709-15-15v-45h-60c-8.284 0-15 6.714-15 15v196h300z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/Anime.596e468c.svg";
export { ForwardRef as ReactComponent };